<template>
	<div class="Settings_Form">
		<div class="grid-x grid-margin-x">
			<div
				class="cell small-12 Settings_Form__border Settings_Form__border--top"
			></div>
			<div class="cell large-6">
				<InputComponent
					type="password"
					v-model="password.old"
					:label="$t('edit.oldPasswordLabel') + ':'"
					:mandatory="true"
					:hasError="validation.passwordOld.error"
					:errorMessage="validation.passwordOld.message"
				/>
			</div>
		</div>
		<div class="grid-x grid-margin-x">
			<div class="cell small-12 large-6">
				<InputComponent
					type="password"
					v-model="password.new"
					:label="$t('edit.newPasswordLabel') + ':'"
					:mandatory="true"
					:hasError="validation.passwordNew.error"
					:errorMessage="validation.passwordNew.message"
				/>
			</div>
			<div class="cell small-12">
				<p>{{ $t('edit.newPasswordInfoText') }}</p>
				<p v-if="passwordInfo != ''">
					<span
						:class="[
							'passwordInfo',
							{ 'passwordInfo--failed': !passwordUpdated }
						]"
					>
						{{ passwordInfo }}
					</span>
				</p>
			</div>
			<div
				class="cell small-12 Settings_Form__border Settings_Form__border--bottom"
			></div>
		</div>
		<div class="grid-x grid-margin-x grid-margin-y">
			<div class="cell small-12">
				<div class="Settings_Form__button">
					<Button
						size="small"
						:loading="loading"
						@click.native="updateUserPassword"
					>
						{{ $t('edit.saveButton') }}
					</Button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import store from '../../../vueX/store'
import { testPassword, validationErrors } from '../../../utilities/validation'

import Button from '../../atoms/Button'
import InputComponent from '../../atoms/InputComponent'

export default {
	name: 'Settings_Form',
	data: () => {
		return {
			loading: false,
			passwordInfo: '',
			passwordUpdated: false,
			user: {},
			password: {
				old: '',
				new: ''
			},
			validation: validationErrors
		}
	},
	components: {
		Button,
		InputComponent
	},
	beforeMount() {
		// Deep clone user
		this.user = JSON.parse(JSON.stringify(this.storeUser))
	},
	methods: {
		validate() {
			let allIsValid = true

			// reset errors and message
			Object.keys(this.validation).map(key => {
				this.validation[key].error = false
				this.validation[key].message = ''
			})

			if (this.password.old == '') {
				this.validation.passwordOld.error = true
				this.validation.passwordOld.message = this.$t('edit.missingPassword')
				return (allIsValid = false)
			}
			if (!testPassword(this.password.old)) {
				this.validation.passwordOld.error = true
				this.validation.passwordOld.message = this.$t('edit.invalidPassword')
				return (allIsValid = false)
			}
			if (this.password.new == '') {
				this.validation.passwordNew.error = true
				this.validation.passwordNew.message = this.$t('edit.missingPassword')
				return (allIsValid = false)
			}
			if (!testPassword(this.password.new)) {
				this.validation.passwordNew.error = true
				this.validation.passwordNew.message = this.$t('edit.invalidPassword')
				return (allIsValid = false)
			}

			return allIsValid
		},

		updateUserPassword() {
			if (this.validate()) {
				this.passwordInfo = ''
				this.loading = true
				const updatedPassword = {
					id: this.user.id,
					oldpassword: this.password.old,
					password: this.password.new
				}

				store.dispatch('REFRESH_TOKEN_BEFORE_REQUEST').then(response => {
					if (response) {
						store
							.dispatch('POST_UPDATE_PASSWORD', updatedPassword)
							.then(success => {
								if (success) {
									this.passwordUpdated = true
									this.passwordInfo = this.$t('edit.passwordChanged')
								} else {
									this.passwordUpdated = false
									this.passwordInfo = this.$t('edit.passwordChangeFailed')
								}
								this.loading = false
							})
					} else {
						this.loading = false
					}
				})
			}
		}
	},
	computed: {
		storeUser() {
			return store.state.user
		}
	}
}
</script>

<style scoped lang="scss">
.Settings_Form {
	background-color: $colorWhite;
	&__border {
		padding-top: 20px;
		&--top {
			border-top: 1px solid #d4d8df;
		}
		&--bottom {
			margin-top: 20px;
			border-bottom: 1px solid #d4d8df;
		}
	}
	&__button {
		justify-content: flex-end;
		display: flex;
		margin: 40px 0 40px 0;
	}
}
.passwordInfo {
	display: inline-block;
	color: $colorGreen;
	margin-top: 10px;
	&--failed {
		color: $colorRed;
	}
}
</style>
